import { sortBy } from 'lodash'

export default function addNumberFieldToPlayersAndReorder(originalPlayers) {
    return sortBy(originalPlayers.map(player => ({
        ...player,
        hashNumber: hashCode(`${player.uuid}-${player.player}`)
    })), 'hashNumber').map(({ hashNumber, ...player }, index) => ({
        ...player,
        number: index + 1
    }))
}

// https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
function hashCode(str) {
    let hash = 0
    if (str.length === 0) return hash
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i)
        hash = ((hash << 5) - hash) + char
        hash &= hash // Convert to 32bit integer
    }
    return hash
}



// WEBPACK FOOTER //
// src/utils/dataEnhancer/utils/addNumberFieldToPlayersAndReorder.js